export enum CustomCurrencyEnum {
    UAH = 'UAH',
}